import Vue from 'vue'
import Router from 'vue-router'
import { staticRoutes } from './staticRoutes'

Vue.use(Router)

// 实例化路由（只加载静态路由）
const createRouter = () => new Router({
  mode: 'history', // 历史模式（需后端配置支持）
  scrollBehavior: () => ({ y: 0 }),
  routes: staticRoutes
})

const router = createRouter()

// 重置路由（解决刷新页面动态路由重复添加问题）
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router